var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.175c-.012-.55-.462-1-1.012-1s-.999.45-.999 1v4.01a.989.989 0 0 1-.987.986H2.985a.989.989 0 0 1-.987-.987V3.167c0-.537.438-.987.987-.987h8.006c.55 0 1-.45 1-.999 0-.55-.45-1-1-1H2.985A2.985 2.985 0 0 0 0 3.168v10.03a2.985 2.985 0 0 0 2.985 2.985h10.03A2.985 2.985 0 0 0 16 13.197V9.175zm-8.006-.412L5.208 5.965a1.003 1.003 0 0 0-1.411 0 1.003 1.003 0 0 0 0 1.411l3.497 3.497c.2.2.45.288.712.288.263 0 .512-.1.712-.287l6.495-6.495a1.003 1.003 0 0 0 0-1.412 1.003 1.003 0 0 0-1.411 0L7.994 8.763z"
  })));
};
export default SvgChecked;